import Component from "@lib/Component.js";
import { addEvent, gebc, addClass, removeClass } from "@qneyraud/q-utils";
import gsap from "gsap";

export default class Partners extends Component {
  init() {
    super.init();
    this.bindMethods();
    this.initListeners();

    this.currentType = "affiliates";
    this.buttonEnabled = true;
  }

  bindMethods() {
    this.onNavButtonClick = this.onNavButtonClick.bind(this);
  }

  initListeners() {
    if (this.refs["nav-button"]) {
      addEvent(this.refs["nav-button"], "click", this.onNavButtonClick);
    }
  }

  onNavButtonClick(e) {
    if (!this.buttonEnabled) return;
    const type = e.currentTarget.dataset.type;

    if (!type) return;

    this.switchToType(type);
  }

  getPanelByType(type) {
    return this.refs.panels.find((panel) => panel.dataset.type === type);
  }

  /**
   *
   * Return AgentAffiliate component instances in the panelElement
   *
   * @param {HTMLElement} panelElement
   */
  getComponentsInPanel(panelElement) {
    const uids = gebc(panelElement, "agent-affiliate", true).map((el) => el.dataset.uid);
    return this.getChildrenById("agent-affiliate").filter((agentAffiliateComponent) => uids.indexOf(agentAffiliateComponent.uid) > -1);
  }

  getButtonByType(type) {
    return this.refs["nav-button"].find((button) => button.dataset.type === type);
  }

  switchToType(type) {
    // Get elements
    const oldPanel = this.getPanelByType(this.currentType);
    const newPanel = this.getPanelByType(type);
    const oldButton = this.getButtonByType(this.currentType);
    const newButton = this.getButtonByType(type);

    if (!oldPanel || !newPanel || !oldButton || !newButton) return;

    gsap
      .timeline({
        onStart: () => {
          removeClass(oldButton, "active");
          addClass(newButton, "active");

          // avoid spam during animation
          this.buttonEnabled = false;
        },
        onComplete: () => {
          this.buttonEnabled = true;
          this.currentType = type;

          // close all old items
          this.getComponentsInPanel(oldPanel).forEach((component) => component.contract());
        }
      })
      .to(gebc(oldPanel, "partners-item", true), {
        duration: 0.3,
        autoAlpha: 0,
        y: -20,
        stagger: 0.15
      })
      .call(() => {
        removeClass(oldPanel, "active");
        addClass(newPanel, "active");
      })
      .fromTo(
        gebc(newPanel, "partners-item", true),
        {
          y: 20
        },
        {
          duration: 0.5,
          autoAlpha: 1,
          y: 0,
          stagger: 0.2
        }
      );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Partners.js